import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./index.css";

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer bg-dark text-white py-4">
        <Container>
          <Row className="align-items-center">
            <Col md="6" className="text-center text-md-left">
              <p className="mb-0">
                &copy; {new Date().getFullYear()} RedditRand. All rights
                reserved.
              </p>
            </Col>
            <Col md="6" className="text-center text-md-right">
              <a href="/about" className="text-white mx-2">
                About Us
              </a>
              <a href="/privacy" className="text-white mx-2">
                Privacy Policy
              </a>
              <a href="/terms" className="text-white mx-2">
                Terms of Service
              </a>
              <a href="/contact" className="text-white mx-2">
                Contact
              </a>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}

export default Footer;
